// src/config/env.ts
// ========================================
// FRONTEND ENVIRONMENT CONFIGURATION
// ========================================

// Frontend URL (wird automatisch erkannt)
const FRONTEND_URL = window.location.origin;
const FRONTEND_HOST = window.location.hostname.toLowerCase();
const isLocalHost = FRONTEND_HOST === 'localhost' || FRONTEND_HOST === '127.0.0.1';
const hasDevMarker =
  FRONTEND_HOST === 'cv-dev.acceler-8.ch' ||
  FRONTEND_HOST.startsWith('cv-dev.') ||
  FRONTEND_HOST.includes('curiculumner-dev') ||
  FRONTEND_HOST.includes('-dev') ||
  FRONTEND_HOST.includes('.dev.') ||
  FRONTEND_HOST.includes('dev.');
const isDevHost = isLocalHost || hasDevMarker;

const DEFAULT_BACKEND_URLS = {
  dev: 'https://europe-west6-curiculumner-dev.cloudfunctions.net/curiculumApiV2',
  prod: 'https://europe-west6-curiculumner.cloudfunctions.net/curiculumApiV2'
};

const FIREBASE_FUNCTIONS_URL = isDevHost
  ? (process.env.REACT_APP_BACKEND_URL_DEV || DEFAULT_BACKEND_URLS.dev)
  : (process.env.REACT_APP_BACKEND_URL || DEFAULT_BACKEND_URLS.prod);

// Environment Detection
const isDevelopment = process.env.NODE_ENV === 'development' || process.env.REACT_APP_ENVIRONMENT === 'development' || isDevHost;
const isProduction =  process.env.REACT_APP_ENVIRONMENT === 'production';

// File Upload Configuration
const MAX_FILE_SIZE = parseInt(process.env.REACT_APP_MAX_FILE_SIZE || '10485760'); // 10MB default
const ALLOWED_FILE_TYPES = process.env.REACT_APP_ALLOWED_FILE_TYPES || 'application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/plain';

// Debug Mode
const DEBUG_MODE = process.env.REACT_APP_DEBUG_MODE === 'true';

export const config = {
  backend: {
    // Firebase Functions Backend
    baseUrl: FIREBASE_FUNCTIONS_URL,
    fullApiUrl: FIREBASE_FUNCTIONS_URL,
    
    // Spezifische Endpoints
    healthEndpoint: '/api/health',
    extractCvEndpoint: '/api/extract-cv',
    optimizeCvEndpoint: '/api/optimize-cv',
    extractProfileEndpoint: '/api/extract-short-profile',
    customShortProfileEndpoint: '/api/custom-short-profile',
    
    // Vollständige URLs
    healthUrl: `${FIREBASE_FUNCTIONS_URL}/api/health`,
    extractCvUrl: `${FIREBASE_FUNCTIONS_URL}/api/extract-cv`,
    optimizeCvUrl: `${FIREBASE_FUNCTIONS_URL}/api/optimize-cv`,
    optimizeCvJsonUrl: `${FIREBASE_FUNCTIONS_URL}/api/optimize-cv`, // Alias für Kompatibilität
    extractProfileUrl: `${FIREBASE_FUNCTIONS_URL}/api/extract-short-profile`,
    customShortProfileUrl: `${FIREBASE_FUNCTIONS_URL}/api/custom-short-profile`,
    userDataUrl: `${FIREBASE_FUNCTIONS_URL}/api/get-encrypted-data`,
    saveDataUrl: `${FIREBASE_FUNCTIONS_URL}/api/save-classified-data`,
    deleteDataUrl: `${FIREBASE_FUNCTIONS_URL}/api/delete-data`, // Für Löschfunktion
  },
  
  frontend: {
    url: FRONTEND_URL,
    isDevelopment,
    isProduction,
    debugMode: DEBUG_MODE
  },
  
  upload: {
    maxFileSize: MAX_FILE_SIZE,
    allowedFileTypes: ALLOWED_FILE_TYPES.split(','),
    maxFileSizeMB: Math.round(MAX_FILE_SIZE / (1024 * 1024))
  },
  
  env: {
    nodeEnv: process.env.NODE_ENV || 'development',
    appEnvironment: process.env.REACT_APP_ENVIRONMENT || 'development',
    isDevelopment,
    isProduction
  },
  
  // Debug-Funktion
  logUrls() {
    if (process.env.NODE_ENV === 'development') {
      console.log('🔧 Firebase Functions Configuration:');
      console.log('Frontend URL:', this.frontend.url);
      console.log('Backend Base URL:', this.backend.baseUrl);
      console.log('Health Check URL:', this.backend.healthUrl);
      console.log('CV Extraction URL:', this.backend.extractCvUrl);
      console.log('CV Optimization URL:', this.backend.optimizeCvUrl);
      console.log('Extract Profile URL:', this.backend.extractProfileUrl);
      console.log('User Data URL:', this.backend.userDataUrl);
      console.log('Save Data URL:', this.backend.saveDataUrl);
      console.log('Environment:', this.env.nodeEnv);
      console.log('App Environment:', this.env.appEnvironment);
      console.log('Debug Mode:', this.frontend.debugMode);
      console.log('Max File Size:', this.upload.maxFileSizeMB + 'MB');
      console.log('Allowed File Types:', this.upload.allowedFileTypes);
    }
  }
};

// Automatisches Logging nur in Development
if (process.env.NODE_ENV === 'development') {
  config.logUrls();
} 